import React from "react";
import { createRoot } from "react-dom/client";
import { FlexBox, Heading, FullScreen, Slide, Deck, Image, Box, Text, Notes, Appear, Link, } from "spectacle";
import "./index.css";
import avatar from "./images/avatar.jpg";
import trazableLogo from "./images/logo_trazable.png";
import ReactAlicanteCover from "./images/first-slides-2022.010-xavier.jpg";
import { ErrorPerformanceSlides } from "./slides/ErrorPerformance";
import { UserPainSlides } from "./slides/UserPain";
import { ThankYouSlide } from "./slides/ThankYou";
import { ReferencesSlide } from "./slides/References";
import { SetupOpenTelemetrySlide } from "./slides/SetupOpentelemetry";
import { WhyObservabilitySlides } from "./slides/WhyObservability";
import { MeasureActionsSlides } from "./slides/MeasureActions";
import { MeasurePageDataLoadSlides } from "./slides/MeasurePageDataLoad";
import example from "./images/example.png";
import { CreateSpanSlide } from "./slides/CreateSpan";
import { MeasurePageLoadNavigationSlides } from "./slides/MeasurePageDataLoadNavigation";
import { FutureSlides } from "./slides/Future";
import { OpenTelemetryIntroSlides } from "./slides/OpenTelemetryIntro";
import { WhatCanWeDoSlides } from "./slides/WhatCanWeDo";
import ReactLogo from "./images/react.png";
var theme = {
    colors: {
        primary: "color: rgb(34 197 94);",
        secondary: "#fff",
    },
};
var Presentation = function () { return (React.createElement(Deck, { theme: theme },
    React.createElement(Slide, { className: "full-slide" },
        window.location.search.includes("react-alicante") ? (React.createElement(Image, { src: ReactAlicanteCover, width: "100%" })) : (React.createElement(FlexBox, { height: "100%", flexDirection: "column" },
            React.createElement(Heading, { margin: "0px" },
                React.createElement("span", { className: "text-green-500" }, "Observability"),
                " in frontend:"),
            React.createElement(Heading, { margin: "0px 32px", fontSize: "h3" }, "React \u2764\uFE0F OpenTelemetry"))),
        React.createElement("div", { className: "absolute bottom-0 left-0 mb-5 ml-5" },
            React.createElement(Box, { padding: "0 1em" },
                React.createElement(FullScreen, null)))),
    React.createElement(Slide, null,
        React.createElement(FlexBox, { justifyContent: "flex-start" },
            React.createElement("div", { className: "border-4 border-green-500 w-fit" },
                React.createElement(Image, { src: avatar, width: 600 })),
            React.createElement("div", { className: "text-white flex items-center flex-col pl-24" },
                React.createElement(Text, null, "Xavier Serrano"),
                React.createElement(Text, null, "Software Engineer \uD83C\uDF0D"),
                React.createElement(Link, { href: "https://twitter.com/Zombispormedio", target: "_blank", className: "text-green-600" }, "@zombispormedio"),
                React.createElement("div", { className: "bg-white mt-20 p-5 " },
                    React.createElement(Image, { src: trazableLogo, width: 300 })))),
        React.createElement(Notes, null, "I am Xavier Serrano. Software engineer, frontend, backend, SRE, whatever. Passionate about observability and 5 years in love with React. I work in Trazable, a startup from Valencia. We make traces and help QAs, but, for food companies.")),
    React.createElement(ErrorPerformanceSlides, null),
    React.createElement(UserPainSlides, null),
    React.createElement(WhatCanWeDoSlides, null),
    React.createElement(WhyObservabilitySlides, null),
    React.createElement(Slide, null,
        React.createElement(FlexBox, { justifyContent: "center", alignContent: "center", height: "100%", flexDirection: "column" },
            React.createElement(Heading, { fontSize: "h3" },
                "Instrument and observe ",
                React.createElement("br", null),
                React.createElement("span", { className: "text-green-600" }, "React applications")),
            React.createElement(Image, { src: ReactLogo, width: 150 })),
        React.createElement(Notes, null, "And here we go to how to instrument clients using OpenTelemetry.")),
    React.createElement(OpenTelemetryIntroSlides, null),
    React.createElement(Slide, null,
        React.createElement(FlexBox, { justifyContent: "center", alignContent: "center", height: "100%", flexDirection: "column" },
            React.createElement(Heading, { fontSize: "h3", className: "underline cursor-pointer" },
                React.createElement("a", { href: "https://github.com/zombispormedio/observable-flora", target: "_blank" }, "FMS (Flower Management System)")),
            React.createElement(Image, { src: example, width: 1000 }),
            React.createElement(Appear, null,
                React.createElement(Text, { className: "text-white" }, "(React Query, Formik and React Router)"))),
        React.createElement(Notes, null, "For this explanation, I created an example with a backend and a frontend using React Query, React Router and Formik to make it more like a real application.")),
    React.createElement(CreateSpanSlide, null),
    React.createElement(SetupOpenTelemetrySlide, null),
    React.createElement(MeasureActionsSlides, null),
    React.createElement(MeasurePageDataLoadSlides, null),
    React.createElement(MeasurePageLoadNavigationSlides, null),
    React.createElement(FutureSlides, null),
    React.createElement(ThankYouSlide, null),
    React.createElement(ReferencesSlide, null))); };
if ("serviceWorker" in navigator) {
    window.addEventListener("load", function () {
        navigator.serviceWorker
            .register("service-worker.js")
            .then(function (registration) {
            console.log("SW registered: ", registration);
        })
            .catch(function (registrationError) {
            console.log("SW registration failed: ", registrationError);
        });
    });
}
createRoot(document.getElementById("root")).render(React.createElement(Presentation, null));
